<button
  #menuTrigger="matMenuTrigger"
  [attr.data-intercom-target]="intercomLabels.USER_MENU"
  [matMenuTriggerFor]="profileMenu"
  matButton
  class="profile-button has-icon"
>
  <div class="profile-name">
    <p class="mat-title-medium">
      {{
        agentFirstName$
          | async
          | truncate
            : {
                start: 0,
                end: 21,
                ellipsis: true,
                summands: [agentLastName$ | async],
              }
      }}
    </p>
    <p class="tenant-name mat-body-small">{{ tenantName$ | async }}</p>
  </div>
  <app-agent-avatar
    [firstName]="(agentFirstName$ | async) ?? ''"
    [lastName]="(agentLastName$ | async) ?? ''"
  ></app-agent-avatar>
</button>

<mat-menu class="profile-menu" #profileMenu="matMenu">
  <app-profile-panel
    [agentFirstName]="(agentFirstName$ | async) ?? ''"
    [agentLastName]="(agentLastName$ | async) ?? ''"
    [agentEmail]="(agentEmail$ | async) ?? ''"
    [canSeeReferralButton]="(canSeeReferralButton$ | async) ?? false"
    (referAFriend)="referAFriend()"
    (logout)="logout()"
  ></app-profile-panel>
</mat-menu>
